import PropTypes from 'prop-types';
import React, {useContext} from 'react';
import {FloatRenderer, TextAlignLeftRenderer} from "../SmartTableRenderers";
import {SQLIndex} from "../../fms.core/constants";
import ApplicationContext from "../../ApplicationContext";
import LookupField from "../../ui/lookup/LookupField";
import {CompanyLookupProps} from "./CompanyLookupField";
import {LookupCompany} from "../../fms.data/lookup";
import CheckBox from "../../ui/CheckBox";

interface CompanyListNotAgentLookupLookupProps extends Omit<Omit<CompanyLookupProps, 'initialValue'>, 'onSelect'> {
  onSelect: (x: LookupCompany|LookupCompany[]) => void,
  fetchAddress: boolean,
  isMultiple: boolean,
  initialValue?: string|null|undefined,
  multiSelectValues?: LookupCompany[]
}

const CompanyListNotAgentLookupField = ({
                                          initialValue = '',
                                          onSelect = () => {
                                          },
                                          placeholder = undefined,
                                          onTextChange = () => {
                                          },
                                          disabled = false,
                                          lookupId = undefined,
                                          onTabNext = undefined,
                                          onTabPrevious = undefined,
                                          companyItems = undefined,
                                          onFocus = () => {
                                          },
                                          onBlur = () => {
                                          },
                                          focusableWhenDisabled = false,
                                          fetchAddress = false,
                                          isMultiple = false,
                                          multiSelectValues = [],
                                          ...others
                                        }: CompanyListNotAgentLookupLookupProps) => {

  const changeSelected = (checked: boolean, selected: LookupCompany) => {
    if (checked) {
      onSelect([...multiSelectValues, selected])
    } else {
      onSelect([...multiSelectValues.filter(item => item.id !== selected.id)])
    }
  }

  const additionalColumns = [];
  if (isMultiple) {
    additionalColumns.push({
      Header: '',
      accessor: 'select',
      resizable: true,
      sortable: false,
      canBeHidden: false,
      visible: true,
      width: 20,
      Cell: ({row}: any) => {
        return <div style={{display: 'block', width: '100%'}}>
            <CheckBox value={!!multiSelectValues?.find(item => item.id === row.original.id)}
                      onChange={(checked) => changeSelected(checked, row.original)}/>
        </div>
      }
    })
  }

  const columns = [
    ...additionalColumns,
    {
      Header: 'Company Name',
      accessor: 'shortName',
      resizable: true,
      sortable: false,
      canBeHidden: false,
      visible: true,
      width: isMultiple ? 210 : 230,
      Cell: TextAlignLeftRenderer
    },
    {
      Header: 'Contact',
      accessor: 'contact',
      resizable: true,
      sortable: false,
      canBeHidden: false,
      visible: true,
      width: 150,
      Cell: TextAlignLeftRenderer
    },
    {
      Header: 'TEL',
      accessor: 'tel',
      resizable: true,
      sortable: false,
      canBeHidden: false,
      visible: true,
      width: 120,
      Cell: TextAlignLeftRenderer
    },
  ]

  const appContext = useContext(ApplicationContext);

  async function queryCompanies(queryString: string | null) {
    const apiResult = await appContext.api.getLookupItems(SQLIndex.CompanyListNotAgnt, queryString || '');
    // return apiResult?.data?.entities || [];
    return apiResult?.entities || [];
  }

  async function _onSelect(x: LookupCompany) {
    if(!isMultiple) {
      if (fetchAddress) {
        const apiResult = await appContext.api.getAddressFromCompanyFile(x.id, false, true, true, true, true, false, false);
        onSelect({...x, addr: apiResult})
      } else {
        onSelect(x)
      }
    }
  }

  function onCancel() {
  }

  function filter(data: Array<LookupCompany>, filterText: string) {
    return data.findIndex(x => x.shortName && x.shortName.toLowerCase().startsWith(filterText.toLowerCase()));
  }

  return (
    <LookupField
      lookupId={lookupId}
      onTabNext={onTabNext}
      onTabPrevious={onTabPrevious}
      disabled={disabled}
      query={queryCompanies}
      width={'520px'}
      columns={columns}
      onSelect={_onSelect}
      onCancel={onCancel}
      labelProp="shortName"
      initialValue={initialValue}
      placeholder={placeholder}
      onTextChange={onTextChange}
      filter={filter}
      onBlur={onBlur}
      onFocus={onFocus}
      focusableWhenDisabled={focusableWhenDisabled}
      isMultiple={isMultiple}
      {...others}
    />
  );
}

CompanyListNotAgentLookupField.defaultProps = {
  onSelect: () => {
  },
  onTextChange: () => {
  },
  filterName: 'shortName',
  disabled: false,
  focusableWhenDisabled: false,
  fetchAddress: false,
  isMultiple: false,
};

CompanyListNotAgentLookupField.propTypes = {
  initialValue: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  onTextChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  filterName: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  lookupId: PropTypes.string,
  onTabNext: PropTypes.func,
  onTabPrevious: PropTypes.func,
  companyItems: PropTypes.array,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  focusableWhenDisabled: PropTypes.bool.isRequired,
  fetchAddress: PropTypes.bool,
  isMultiple: PropTypes.bool
};


export default React.memo(CompanyListNotAgentLookupField);